export default __webpack_public_path__ + "static/media/ed_5.dd72dce1.mp3";